import styled from '@emotion/styled';
import Table from 'app/components/Table';

export const StyledSubTable = styled(Table)`
  thead > tr {
    th {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0.005em;
      text-align: left;
    }
  }
  tbody > tr > td {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.005em;
    color: #232b3a;
  }
  tbody > tr {
    &.hovered > td {
      background: #f6f9ff;
      &.ant-table-cell-row-hover {
        background: #f6f9ff !important;
      }
    }
  }
  &.child {
    thead > tr > th {
      background: #f7f7f7;
    }
  }

  &.hovered {
    thead > tr > th {
      background: #f6f9ff !important;
    }
    tbody > tr > td {
      background: #f6f9ff !important;
    }
  }
`;

export const StyledTable = styled(Table)`
  .ant-table-expanded-row {
    &.ant-table-expanded-row-level-1 {
      > td {
        padding: 0;
      }
    }
  }
`;

export const ExpandedRowContainer = styled.div`
  background: #f6f8fa; /* Light gray background */
  border-radius: 4px;
`;
